module.exports = __webpack_public_path__ + "img/4e862fd.png";